import axios from "axios";
import config from "./config";

class APIReports {
  static async getPatientTimeline({ fromDate, toDate, piwId, user }, signal) {
    return new Promise(function (resolve, reject) {
      axios
        .post(
          config.apiReports + "/patient-timeline",
          {
            from_date: fromDate,
            to_date: toDate,
            piw_id: piwId,
            user,
          },
          { signal }
        )
        .then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            resolve(null);
          }
        })
        .catch(function (error) {
          if (error?.message !== "canceled") {
            reject(error);
          }
        });
    });
  }

  static async getLiveDashboardData(
    fromDate,
    toDate,
    facility,
    majorsBeds,
    utcBeds,
    acaBeds,
    signal
  ) {
    return new Promise(function (resolve, reject) {
      axios
        .post(
          config.apiReports + "/dashboard-lite/live-dashboard",
          {
            start_date: fromDate,
            end_date: toDate,
            facility,
            majors_beds: majorsBeds,
            utc_beds: utcBeds,
            aca_beds: acaBeds,
          },
          { signal }
        )
        .then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            resolve(null);
          }
        })
        .catch(function (error) {
          if (error?.message !== "canceled") {
            reject(error);
          }
        });
    });
  }

  static async getEstimatedWaitingTime(facility, signal) {
    return new Promise(function (resolve, reject) {
      axios
        .get(config.apiReports + `/dashboard-lite/waiting-time/${facility}`, {
          signal,
        })
        .then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            resolve(null);
          }
        })
        .catch(function (error) {
          if (error?.message !== "canceled") {
            reject(error);
          }
        });
    });
  }

  // ED Dashboard Statistics
  static async getMainEDDashboardStats(facility, bedRequestType, wardId, signal) {
    return new Promise(function (resolve, reject) {
      axios
        .post(
          config.apiReports + "/dashboard-lite/ed",
          { facility, bedRequestType, wardId },
          { signal }
        )
        .then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            resolve(null);
          }
        })
        .catch(function (error) {
          if (error?.message !== "canceled") {
            reject(error);
          }
        });
    });
  }

  // ED Dashboard Bed Statistics
  static async getEDDashboardBedsStats(facility, bedRequestType, wardId, signal) {
    return new Promise(function (resolve, reject) {
      axios
        .post(
          config.apiReports + "/dashboard-lite/ed/beds",
          { facility, bedRequestType, wardId },
          { signal }
        )
        .then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            resolve(null);
          }
        })
        .catch(function (error) {
          if (error?.message !== "canceled") {
            reject(error);
          }
        });
    });
  }

  // ED Dashboard ED Breaches Statistics
  static async getEDDashboardEDBreachesStats(facility, bedRequestType, wardId, signal) {
    return new Promise(function (resolve, reject) {
      axios
        .post(
          config.apiReports + "/dashboard-lite/ed/breach",
          { facility, bedRequestType, wardId },
          { signal }
        )
        .then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            resolve(null);
          }
        })
        .catch(function (error) {
          if (error?.message !== "canceled") {
            reject(error);
          }
        });
    });
  }
}

export default APIReports;
